import { ErrorBoundary } from '@sentry/react'
import { startCase } from 'lodash-es'
import React, { useEffect, useState } from 'react'
import { Countdown } from '~/components/Countdown'
import {
	Articles,
	BatchSection,
	Blogs,
	ComparisonSection,
	InTheBoxSection,
	ReviewsSection,
	StepsSection
} from '~/components/sections'
import { DynamicPortal } from '~/components/utils'
import { AllProducts, Collection } from '~/pages/Products'
import { CountryCode, Nullable } from '~/types'
import { useReadyState } from '~/utils'
import { useCountry } from '../Locale'

//

export const Sections: React.FC = () => {
	const state = useReadyState()
	const [sections, setSections] = useState(window.Sections)
	const country = useCountry()
	useEffect(() => {
		if (!window.Shopify.designMode) return
		const events = ['shopify:section:load', 'shopify:section:reorder']
		function onChange(e: Event) {
			const elem = e.target as Nullable<HTMLElement>
			const script = elem?.querySelector('script')
			if (script && elem) {
				window.Sections = window.Sections.filter(section => section.id !== `#${elem.id}`)
				// eslint-disable-next-line no-eval
				eval(script.innerText)
			}
			setSections([...window.Sections])
		}
		events.forEach(evt => window.addEventListener(evt, onChange))
		return () => {
			events.forEach(evt => window.removeEventListener(evt, onChange))
		}
	}, [])

	useEffect(() => {
		if (country.iso_code !== CountryCode.CA) return
		function hideAuk1() {
			document
				.querySelectorAll('a[href="/products/auk"], a[href*="/products/auk?"]')
				.forEach(a => ((a as HTMLAnchorElement).style.display = 'none'))
		}
		hideAuk1()
		document.addEventListener('click', hideAuk1)
		document.addEventListener('DOMContentLoaded', hideAuk1)
		return () => {
			document.removeEventListener('click', hideAuk1)
			document.removeEventListener('DOMContentLoaded', hideAuk1)
		}
	})
	return state !== 'complete' ? null : (
		<>
			{sections?.map(section => (
				<ErrorBoundary key={section.id} onError={e => console.warn(`${startCase(section.name)} Error`, e)}>
					<DynamicPortal selector={section.id}>
						{section.name === 'Comparison' && <ComparisonSection section={section} />}
						{section.name === 'Reviews' && <ReviewsSection section={section} />}
						{section.name === 'Steps' && <StepsSection section={section} />}
						{section.name === 'Blogs' && <Articles section={section} />}
						{section.name === 'BlogList' && <Blogs />}
						{section.name === 'Batches' && <BatchSection section={section} />}
						{section.name === 'InTheBox' && <InTheBoxSection section={section} />}
						{section.name === 'list-collections-template' && <AllProducts section={section} />}
						{section.name === 'collection-section' && <Collection section={section} />}
						{}
					</DynamicPortal>
				</ErrorBoundary>
			))}
			<DynamicPortal
				selector=".countdown[data-to]"
				multiple
				render={e => {
					const date = e.getAttribute('data-to')
					return date ? <Countdown to={new Date(date)} /> : null
				}}
			/>
		</>
	)
}
